/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetContractTemplateResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'ContractTemplate',
        isRequired: true,
      },
    },
  }],
} as const;
